import { CLASS_NAMES } from "../../utils/constants"
import Destroyable from "./Destroyable"

export default class Deco extends Destroyable {
  
}

Deco.className = CLASS_NAMES.DECO